import { Grid, Text, useMediaQuery } from '@geist-ui/react'
import { useNavigate } from 'react-router-dom'

import { ReactComponent as LogoSvg } from '../../assets/home_logo_center.svg'
import { ReactComponent as LogoMobileSvg } from '../../assets/home_logo_center_mobile.svg'

export const Home = () => {
  const navigate = useNavigate()

  const isXs = useMediaQuery('xs')

  const fontSize = '36px'

  return (
    <Grid.Container gap={0} justify="center" style={{ height: '70vh' }}>
      <Grid
        id="graphic"
        className="center logo-transition"
        xs={24}
        md={8}
        onClick={() => navigate('./graphic')}
      >
        <Text className='lato-light' font={fontSize}>GRAPHIC</Text>
      </Grid>
      <Grid id="center-logo" xs={24} md={8} className='center'>
        {
          isXs
            ? <LogoMobileSvg style={{ height: '100%' }} />
            : <LogoSvg style={{ height: '100%' }} />
        }
      </Grid>
      <Grid
        id="illustration"
        className="center logo-transition"
        xs={24}
        md={8}
        onClick={() => navigate('./illustration')}
      >
        <Text className='lato-light' font={fontSize}>ILLUSTRATION</Text>
      </Grid>
    </Grid.Container>
  )
}
